import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "InputProps"],
  _excluded2 = ["startAdornment", "endAdornment"];
import React from 'react';
import { TextFieldSearch } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */
function SearchField(_ref) {
  let {
      onChange,
      InputProps
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [textFieldValue, setTextFieldValue] = React.useState('');
  const handleChange = value => {
    setTextFieldValue(value);
    onChange(value);
  };
  const _ref2 = InputProps != null ? InputProps : {},
    {
      endAdornment
    } = _ref2,
    inputCustomProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(TextFieldSearch, _extends({
    sx: {
      maxWidth: '230px',
      flexGrow: 1
    },
    InputProps: _extends({
      // eslint-disable-next-line react/jsx-no-useless-fragment
      endAdornment: endAdornment && /*#__PURE__*/_jsx(React.Fragment, {
        children: endAdornment
      })
    }, inputCustomProps),
    size: "small",
    value: textFieldValue,
    onChange: value => handleChange(value)
  }, props));
}
export default SearchField;